<div class="floating-tips-container d-none d-lg-block" *ngIf='currentStep!=TIPS_STEPS.NONE' (click)='onClose()'>
  <div style="position: relative;" class='w-100 h-100'>
    <div class="new-card centered" (click)='$event.stopPropagation();'>
      <div class="new-card-header">
        <button type="button" class="close" aria-label="Close" (click)='onClose()'>
          <span aria-hidden="true">&times;</span>
        </button>

      </div>

      <!-- ABRIR VISOR SIMPLE -->
      <div class="new-card-body text-golden" *ngIf="currentStep==TIPS_STEPS.BOOK_OPEN_VISOR">
        <div class="row justify-content-center mb-4" style="font-size: 18px;">
          {{"MENU.HELP_DATA.TEXT_1" | translate}}
        </div>
        <img style="max-width: 100%;max-height: 100%; border: 1px solid #5B76AB;" src="assets/img/tips/open_image.gif"
          alt="simple_viewer">
      </div>

      <!-- ABRIR VISOR AVANZADO -->
      <div class="new-card-body text-golden" *ngIf="currentStep==TIPS_STEPS.CAN_OPEN_STUDIES">
        <div class="row justify-content-center mb-4" style="font-size: 18px;">
          {{"MENU.HELP_DATA.TEXT_2" | translate}}
        </div>
        <img style="max-width: 100%;max-height: 100%; border: 1px solid #5B76AB;" src="assets/img/tips/open_visor.gif"
          alt="medical_viewer">
      </div>

      <!-- COMPARACIÓN ESTUDIOS MAMO -->
      <div class="new-card-body text-golden" *ngIf="currentStep==TIPS_STEPS.COMP_MAMO">
        <div class="row justify-content-center mb-4" style="font-size: 18px;">
          {{"MENU.HELP_DATA.TEXT_3" | translate}}
        </div>
        <img style="max-width: 100%;max-height: 100%; border: 1px solid #5B76AB;"
          src="assets/img/tips/open_historic.gif" alt="medical_viewer">
      </div>

      <!-- <button class='btn btn-primary my-4 mx-5' (click)='onClose()'>Cerrar</button> -->
      <div class="new-card-footer text-golden" *ngIf="stepsLength>1">
        <div class="w-100 h-100 d-flex justify-content-center align-items-center">
          <div>
            <span class="clickable me-1" style="font-size: 18px;" (click)="onPrev()" *ngIf="hasPrev">
              <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                <path fill="#F2C63D" d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z" />
              </svg>
            </span>
          </div>
          <span>
            {{currentStepIndex+1}}/{{stepsLength}}
          </span>
          <div>
            <span class="clickable ms-1" style="font-size: 18px;" (click)="onNext()" *ngIf="hasNext">
              <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                <path fill="#F2C63D" d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>